import {Component} from '@angular/core';
import {Router} from "@angular/router";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {RegistrationService} from "../../../services/register.service";

@Component({
  selector: 'app-registration-landing',
  templateUrl: './registration-landing.component.html',
  styleUrls: ['./registration-landing.component.scss']
})
export class RegistrationLandingComponent {
  preRegisterForm: FormGroup = new FormGroup({
    name: new FormControl('', [
      Validators.required,
      Validators.maxLength(160)
    ])
  });

  constructor(private router: Router,
              private registrationService: RegistrationService) {
  }

  onSubmit() {
    if (this.preRegisterForm.valid) {
      const name = this.preRegisterForm.get('name')?.value;

      this.registrationService.setOrganizationName(name);

      this.router.navigate(['/registration-form']);
    }
  }


}
